import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let CustomTheme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
    // fontSize: 14,
    title: {
      fontSize: "24px", 
      fontWeight: 600,
      lineHeight: 1.2,
    },
    subtitle: {
      fontSize: "18px", 
      fontWeight: 500,
      lineHeight: 1.3,
    },
    body: {
      fontSize: "14px", 
      fontWeight: 400,
      lineHeight: 1.4,
    },
    note: {
      fontSize: "12px", 
      fontWeight: 400,
      lineHeight: 1.4,
    },

    // // ---- SUBTITLE ----
    // subtitle1: {
    //   fontSize: "16px", // 16px
    //   fontWeight: 500,
    //   lineHeight: 1.4,
    // },
    // subtitle2: {
    //   fontSize: "14px", // 14px
    //   fontWeight: 500,
    //   lineHeight: 1.4,
    // },

    // // ---- BODY TEXT ----
    // body1: {
    //   fontSize: "14px", // 14px
    //   lineHeight: 1.5,
    // },
    // body2: {
    //   fontSize: "13px", // 13px
    //   lineHeight: 1.45,
    // },

    // // ---- SMALL TEXT ----
    // caption: {
    //   fontSize: "11px", // 11px
    //   color: "#888",
    //   lineHeight: 1.4,
    // },
    // overline: {
    //   fontSize: "10px", // 10px
    //   textTransform: "uppercase",
    //   letterSpacing: "0.06em",
    // },
  },
  palette: {
    DataGrid: {
      headerBg: "#142d25ff",
      toolbarBg: "#142d25ff",
    },
    primary: {
      light: "#919d96d5",
      main: "#39493F",
      dark: "#183021ff",
      contrastText: "#fff",
    },
    secondary: {
      light: "#f8dc9bff",
      main: "#FFD166",
      dark: "#fabf36ff",
    },
    tertiary: {
      light: "#fdfeffff",
      main: "#BCBEC0",
      dark: "#6b6b6cff",
      contrastText: "#fff",
    },
    background: {
      light: "#eff2d9ff",
      main: "#FFFEFA",
      dark: "#93957cff",
      contrastText: "#1A1A1A",
    },
  },
  components: {
  MuiDataGrid: {
    styleOverrides: {
      root: ({ theme }) => ({
        border: "none",
        display: "flex",
        justifyContent: "space-around",
        backgroundColor: theme.palette.background.main,

        "& .MuiDataGrid-scrollbar": {
          height: "auto",
        },

        // ✅ Filter header background
        "& .MuiDataGrid-columnHeader--filter": {
          backgroundColor: "#FFFEFA",
        },

        // ✅ Column menu (three dots) icon
        "& .MuiDataGrid-menuIconButton": {
          color: "#FFFEFA",
        },

        // ✅ Sorting icons (up/down)
        "& .MuiDataGrid-sortIcon": {
          color: "#FFFEFA",
        },

        // ✅ Filter icon (funnel)
        "& .MuiDataGrid-filterIcon": {
          color: "#FFFEFA",
        },

        // ✅ Hover color for header icons
        "& .MuiDataGrid-columnHeader:hover .MuiSvgIcon-root": {
          color: "#FFFEFA",
        },
      }),

      columnHeaders: {
        color: "#f0f0f0",
      },

      row: {
        backgroundColor: "#FFFEFA",
        border: "none",
        "&.Mui-selected": {
          backgroundColor: "#f5f5f5 !important",
        },
      },

      checkboxInput: {
        color: "#959968ff",
        "&.Mui-checked": {
          color: "#959968ff",
        },
        "&.MuiCheckbox-indeterminate": {
          color: "#959968ff",
        },
      },
    },
  },

  MuiTab: {
    styleOverrides: {
      root: {
        "&.Mui-selected": {
          backgroundColor: "#39493F",
          color: "white",
        },
      },
    },
  },

  MuiDateCalendar: {
    styleOverrides: {
      root: {
        color: "#39493F",
        borderRadius: "5px",
        borderColor: "#CBCEA7",
        backgroundColor: "#EAEBDC",
      },
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        fontSize: "14px",
        "& fieldset": { borderColor: "primary.main" },
        "&:hover fieldset": { borderColor: "primary.light" },
        "&.Mui-focused fieldset": { borderColor: "primary.main" },
      },
    },
  },
},

});

// ✅ make font sizes responsive
CustomTheme = responsiveFontSizes(CustomTheme);

export default CustomTheme;
